module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-miterlimit=\"10\" d=\"M16 10l-4 4-4-4\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/svg/arrow-down.svg
// module id = 1508
// module chunks = 0